<template>
  <header :class="['header-container', {'is-active-menu': isActiveMenu && $activeFixedHeader}]">
    <transition v-if="$isActiveHeaderTransition"
                mode="out-in"
                name="fade-opacity-lazy">
      <div class="main-header-container" v-if="!$activeFixedHeader">
        <div class="logo-container" @click="$emit('scrollToTop')">
          <img :src="getUrlLogo('logo')" alt="logo">
        </div>
        <menu-item  :menu-info="menuInfo"
                    @scrollTo="value => scrollTo(value, true)"/>
        <main-button
            @click="IS_ACTIVE_MODAL(true)">
          {{ btnText }}
        </main-button>
      </div>
      <div class="main-header-container" v-else>
        <div class="top-container">
          <div class="logo-container" @click="changeStateMenu">
            <img :src="getUrlLogo(isLogoDark && !isActiveMenu
            ? 'logo-icon-dark'
            : 'logo-icon')" alt="logo">
          </div>
          <transition name="fade-opacity-lazy">
            <div class="icon-container"
                 v-if="isActiveMenu"
                 @click="changeStateMenu">
              <img :src="getUrlIcons('cross-white')" alt="logo">
            </div>
          </transition>
        </div>
      </div>
    </transition>

    <transition name="fade-translate-y-card-revert">
      <menu-burger v-show="isActiveMenu && $activeFixedHeader"
                   @scrollTo="scrollTo"
                   :menu-info="menuInfo"/>
    </transition>
  </header>
</template>

<script>
import MenuItem from "@/components/widgets/MenuItem.vue";
import MainButton from "@/components/shared/MainButton.vue";
import {mapActions, mapState} from "vuex";
import MenuBurger from "@/components/widgets/MenuBurger.vue";

export default {
  name: "MainHeaderDesktop",
  components: {MenuBurger, MainButton, MenuItem},
  props: {
    menuInfo: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      btnText: 'Оставить заявку',
      isActiveMenu: false
    }
  },
  computed: {
    ...mapState('scrollModule',['optionsHorizontalScroll']),
    ...mapState(['$isActiveHeaderTransition', '$activeWhiteBlock', '$isHistoryScreen']),
    isLogoDark() {
      return this.$isHistoryScreen
          ? this.isLogoDarkForSlide
          : this.$activeWhiteBlock
    },
    isLogoDarkForSlide() {
      return this.optionsHorizontalScroll?.currentSlide !== 0;
    },
  },
  methods: {
    ...mapActions(['IS_ACTIVE_MODAL']),
    changeStateMenu() {
      this.isActiveMenu = !this.isActiveMenu
    },
    scrollTo(id, isSmoothScroll = false) {
      this.$emit('scrollTo', id, isSmoothScroll);
      this.$nextTick(() => {
        this.isActiveMenu = false;
      })
    }
  },
}
</script>

<style scoped lang="scss">

.header-container {
  position: fixed;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;

  transition: all .3s ease;


  &.is-active-menu {
    top: 0 !important;
  }

  .main-header-container {
    margin: 0 auto;
    max-width: var(--sub-max-width);
    padding: 0 var(--var-padding);
    transition: all .5s ease;
    z-index: 20;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .top-container {
      margin-top: 0;
      transition:  all .3s ease;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .logo-container {
        & img {
          width: 100%;
          height: 100%;
        }
      }

      .icon-container {
        position: relative;
        cursor: pointer;
        transition: all .3s ease;
        &:hover {
          opacity: .6;
        }
        & img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .logo-container {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      transition: all .3s ease;

      &:hover {
        opacity: .6;
      }

      & img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 3024px){
  .header-container {
    top: 60px;

    &.is-active-menu {
      .main-header-container {
        .top-container {
          margin-top: 60px;
        }
      }
    }

    .main-header-container {
      .logo-container {
        max-width: 150px;
      }

      .top-container {
        .logo-container {
          width: 110px;
          height: 95px;
        }

        .icon-container {
          width: 64px;
          height: 64px;
          padding: 20px;
        }
      }
    }
  }
}

@media (max-width: 1920px) {
  .header-container {

    .main-header-container {
      .logo-container {
        max-width: 122px;
      }

      .top-container {
        .logo-container {
          width: 90px;
          height: 75px;
        }

        .icon-container {
          width: 52px;
          height: 52px;
          padding: 16px;
        }
      }
    }
  }
}
@media (max-width: 1600px) {
  .header-container {
    top: 40px;

    &.is-active-menu {
      .main-header-container {
        .top-container {
          margin-top: 40px;
        }
      }
    }

    .main-header-container {
      .logo-container {
        max-width: 104px;
      }

      .top-container {
        .logo-container {
          width: 65px;
          height: 45px;
        }

        .icon-container {
          width: 46px;
          height: 46px;
          padding: 16px;
        }
      }
    }
  }
}
@media (max-height: 800px) {
  .header-container {
    .main-header-container {
      .logo-container {
        max-width: 85px;
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .header-container {
    .main-header-container {
      .logo-container {
        max-width: 104px;
      }
    }
  }
}

@media (max-width: 1133px) {
  .header-container {
    .main-header-container {
      .logo-container {
        max-width: 85px;
      }
    }
  }
}
@media (max-width: 769px) {
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .header-container {
    top: 80px;

    &.is-active-menu {
      .main-header-container {
        .top-container {
          margin-top: 80px;
        }
      }
    }

    .main-header-container {
      .logo-container {
        max-width: 290px;
      }


      .top-container {
        .logo-container {
          width: 160px;
          height: 130px;
        }

        .icon-container {
          width: 100px;
          height: 100px;
          padding: 30px;
        }
      }
    }
  }
}

</style>